import * as AC from 'components/actions/actionTypes';
import _ from 'lodash';
import moment from 'moment';
import ReservationReducerHelper from './helpers/ReservationReducerHelper';
import PriceList from 'components/common/helpers/PriceList';
import { STATUS_CANCELED } from 'components/common/constants/reservationStatusConstants';

let defaultState = {
  notification: { id: null, params: null },
  busStops: [],
  customerAddresses: [],
  refreshCustomerAddressesList: 0,
  editedReservation: null,
  priceList: null,
  dashboardReservations: [],
  myTrips: [],
  myTripsDate: null,
  reservationToReview: null,
};

let defaultReservationUpdateState = {
  paramsForReservationUpdate: {
    selectedCardId: null,
    id: null,
    adults: 0,
    children: 0,
    students: 0,
    price: 0,
    address: {
      phrase: '',
      selectedObject: null,
      postcode: null,
      street: null,
      error: null,
      lat: null,
      lng: null
    },
    kidsSafety: {
      noNeedCarSeat: 0,
      cradle: 0,
      seatWithSeatBelts: 0,
      seatWithoutSeatBelts: 0,
      carSeatPad: 0
    }
  }
};

let initialState = _.merge({}, defaultState, defaultReservationUpdateState);

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case AC.REFRESH_CUSTOMER_ADDRESSES_LIST:
      var value = state.refreshCustomerAddressesList + 1;
      return _.merge(
        {},
        state,
        { refreshCustomerAddressesList: value }
      );

    case AC.SET_CUSTOMER_ADDRESSES:
      var newState = _.merge({}, state);
      newState.customerAddresses = action.addresses;
      return newState;

    case AC.SET_RESERVATION_TO_EDIT:
      var newState = _.merge({}, state);
      newState.editedReservation = action.reservation;
      var helper = new ReservationReducerHelper(action.reservation);
      newState.paramsForReservationUpdate = helper.setupDefaultParamsForReservationUpdate()
      return newState;

    case AC.SET_KIDS_SAFETY_IN_RESERVATION:
      return _.merge(
        {},
        state,
        {
          paramsForReservationUpdate: {
            kidsSafety: action.value
          }
        }
      );

    case AC.SET_CHILDREN_NUMBER_IN_RESERVATION_EDIT:
      return _.merge(
        {},
        state,
        {
          paramsForReservationUpdate: {
            children: action.number,
          },
        }
      );

    case AC.SET_ADULTS_NUMBER_IN_RESERVATION_EDIT:
      return _.merge(
        {},
        state,
        {
          paramsForReservationUpdate: {
            adults: action.number,
          },
        }
      );

      case AC.SET_STUDENTS_NUMBER_IN_RESERVATION_EDIT:
        return _.merge(
          {},
          state,
          {
            paramsForReservationUpdate: {
              students: action.number,
            },
          }
        );


    case AC.SET_NEW_PRICE_RESERVATION_EDIT:
      return _.merge(
        {},
        state,
        {
          paramsForReservationUpdate: {
            price: getPriceForEditReservation(state, action.priceList)
          },
        }
      );

    case AC.SET_ADDRESS_IN_RESERVATION_EDIT:
      var newState = _.merge({}, state);
      newState.paramsForReservationUpdate.address = action.value;
      return newState;

    case AC.SET_PRICE_LIST:
      return _.merge({}, state, { priceList: action.list });

    case AC.SET_CARD_ID_IN_RESERVATION_EDIT:
      return _.merge({}, state, { paramsForReservationUpdate: { selectedCardId: action.value } });

    case AC.RESET_RESERVATION_UPDATE_DATA:
      var newState = _.merge({}, state);
      newState.paramsForReservationUpdate = defaultReservationUpdateState.paramsForReservationUpdate;
      return newState;

    case AC.RESET_KIDS_SAFETY_IN_RESERVATION_EDIT:
      var newState = _.merge({}, state);
      newState.paramsForReservationUpdate.kidsSafety = {
        noNeedCarSeat: 0,
        cradle: 0,
        seatWithSeatBelts: 0,
        seatWithoutSeatBelts: 0,
        carSeatPad: 0
      };
      return newState;

    case AC.CREATE_NOTIFICATION:
      if (state.notification.id === null) {
        var newId = 1;
      } else {
        var newId = state.notification.id + 1;
      }
      return _.merge({}, state, { notification: { id: newId, params: action.params } });

    case AC.SET_DASHBOARD_RESERVATIONS:
      var newState = _.merge({}, state);
      newState.dashboardReservations = action.reservations;
      return newState;

    case AC.SET_MY_TRIPS:
      var newState = _.merge({}, state);
      newState.myTrips = action.trips;
      return newState;

    case AC.SET_BUS_STOP_LIST:
      var newState = _.merge({}, state);
      newState.busStops = action.payload;
      return newState;

    case AC.SET_RESERVATION_TO_REVIEW:
      var newState = _.merge({}, state);
      newState.reservationToReview = action.reservation;
      return newState;

    case AC.SET_FILTER_DATE_IN_TRIPS:
      var newState = _.merge({}, state);
      newState.myTripsDate = action.date;
      return newState;

    case AC.SET_USER_LOGOUT:
      var newState = _.merge({}, state);
      newState.customerAddresses = [];
      newState.myTrips = [];
      newState.myTripsDate = [];
      return newState;

    case AC.HIDE_REVIEW_FORM_IN_RESERVATION:
      var newState = _.merge({}, state);
      var reservation = _.find(newState.dashboardReservations, { id: action.id })
      var myTrip = _.find(newState.myTrips, { id: action.id })
      if (reservation) {
        reservation.hide_rate_form = true;
      }
      if (myTrip) {
        myTrip.hide_rate_form = true;
      }
      return newState;

    case AC.CANCEL_RESERVATION:
      var newState = _.merge({}, state);
      var reservation = _.find(
        newState.dashboardReservations,
        {
          id: action.id,
          reservation_direction: action.reservationDirection,
          reservation_type: action.reservationType
        }
      );
      reservation.status = STATUS_CANCELED;
      reservation.cancelled_with_refund = action.cancelledWithRefund;
      return newState;

    case AC.OVERRIDE_RESERVATION:
      var newState = _.merge({}, state);
      for (var i = 0; i < newState.dashboardReservations.length; i++) {
        if (newState.dashboardReservations[i].id === action.reservation.id) {
          newState.dashboardReservations[i] = action.reservation;
          break;
        }
      }

      for (var i = 0; i < newState.myTrips.length; i++) {
        if (newState.myTrips[i].id === action.reservation.id) {
          newState.myTrips[i] = action.reservation;
          break;
        }
      }
      return newState;

    default:
      return state;
  }
}

function getPriceForEditReservation(state, priceList) {
  var selectedObject = state.paramsForReservationUpdate.address.selectedObject;
  if (selectedObject.g) {
    var busStopName = null;
    var postcode = state.paramsForReservationUpdate.address.postcode;
  } else {
    var busStopName = selectedObject.value;
    var postcode = null;
  }
  var adults = state.paramsForReservationUpdate.adults;
  var children = state.paramsForReservationUpdate.children;
  var students = state.paramsForReservationUpdate.students;
  var stateParams = {
    busStopName,
    postcode,
    adults,
    children,
    students
  };

  var airportCode = state.editedReservation.flight.airport.code;
  var priceParams = _.merge({}, stateParams);
  return new PriceList(priceList, airportCode).getTotalPrice(priceParams);
}
